import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import {
  skipSaveBodyqewhiekddpy3 as skipSaveBody,
  get_isSaved1yor47kvbhumv as get_isSaved,
} from '../plugins/SaveBody.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { save1hc0jjdmqj6mp as save } from '../call/SavedCall.mjs';
import { get_job2zvlvce9o9a29 as get_job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CompletableJob1w6swnu15iclo as CompletableJob } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableJob.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpStatementClass;
function HttpStatement() {
  if (HttpStatementClass === VOID) {
    class $ {
      constructor(builder, client) {
        this.i5x_1 = builder;
        this.j5x_1 = client;
      }
      *j5z($completion) {
        return yield* this.k5z($completion);
      }
      *k5x($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).p5o(this.i5x_1);
            skipSaveBody(builder);
            var call = yield* this.j5x_1.w5k(builder, $completion);
            return call.q5j();
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *k5z($completion) {
        $l$block: {
          // Inline function 'io.ktor.client.plugins.unwrapRequestTimeoutException' call
          try {
            var builder = (new (HttpRequestBuilder())()).p5o(this.i5x_1);
            var call = yield* this.j5x_1.w5k(builder, $completion);
            var result = (yield* save(call, $completion)).q5j();
            yield* this.l5x(call.q5j(), null, $completion);
            return result;
          } catch ($p) {
            if ($p instanceof CancellationException()) {
              var cause = $p;
              throw unwrapCancellationException(cause);
            } else {
              throw $p;
            }
          }
        }
      }
      *l5x(_this__u8e3s4, cause, $completion) {
        var tmp = get_job(_this__u8e3s4.ww());
        var job = isInterface(tmp, CompletableJob()) ? tmp : THROW_CCE();
        // Inline function 'kotlin.apply' call
        if (cause == null)
          job.o13();
        else {
          if (cause instanceof CancellationException()) {
            job.gy(cause);
          } else {
            job.gy(CancellationException().p('Exception occurred during request execution', cause));
          }
        }
        if (!get_isSaved(_this__u8e3s4)) {
          try {
            cancel(_this__u8e3s4.d5m());
          } catch ($p) {
            if ($p instanceof Error) {
              var _unused_var__etf5q3 = $p;
            } else {
              throw $p;
            }
          }
        }
        yield* job.dy($completion);
        return Unit_instance;
      }
      toString() {
        return 'HttpStatement[' + this.i5x_1.x5k_1.toString() + ']';
      }
    }
    initMetadataForClass($, 'HttpStatement', VOID, VOID, VOID, [1, 0, 2]);
    HttpStatementClass = $;
  }
  return HttpStatementClass;
}
//region block: exports
export {
  HttpStatement as HttpStatement3zxb33q8lku,
};
//endregion

//# sourceMappingURL=HttpStatement.mjs.map
